const categories = [
  { icon: "ri-building-2-line", label: "Construction & Project Delivery" },
  { icon: "ri-ruler-line", label: "Architecture & Engineering" },
  { icon: "ri-scales-3-line", label: "Legal & Compliance" },
  { icon: "ri-heart-pulse-line", label: "Clinical Practices" },
];

export default function TrustStrip() {
  return (
    <section
      className="bg-[#F7F8FA] border-y border-[#E5E7EB] py-12 px-6 md:px-10"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-sm text-[#6B7280] font-normal mb-10 tracking-wide">
          Built for industries where precision, compliance, and execution matter most.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map(({ icon, label }) => (
            <div
              key={label}
              className="flex flex-col items-center gap-3 py-6 px-4 bg-white rounded-[12px] border border-[#E5E7EB] hover:shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-[10px] bg-[#F7F8FA]">
                <i className={`${icon} text-xl text-[#4F46E5]`}></i>
              </div>
              <span className="text-sm font-medium text-[#1F2933] text-center leading-snug">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
